<template>
    <div class="fullHeight">
        <MypageSideMenu @set="initialize" :memberDropClose="true"/>
        <Card
            :page_title="page_title"
            iconclass="iconline mypage-title-icon"
            >
            <div class="col-sm-12">
                <div>
                    <div class="row">
                        <div class="col-sm-12">
                            <p class="text-center">LINEアカウントと連携します。よろしいですか？</p>
                        </div>
                        <div class="col-sm-12" v-if="error_message_val">
                            <p class="text-center text-red mb-0">{{ error_message }}</p>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-center mb-4">
                    <div class="lineBtn longBtn">
                        <div class="lineBtn__inner" v-on:click="lineLink">LINEアカウント連携</div>
                    </div>
                </div>
            </div>
        </Card>
        <MypageMenuFooter/>
    </div>
</template>

<script>
import MypageSideMenu from './MypageSideMenu';
import MypageHeader from './MypageHeader';
import Card from '../components/Card';
import { GET_SOCIAL_AUTH_URL, LINK_SOCIAL_ACCOUNT_TO_MEMBER } from '../../constants/line_link';
import { createApollo } from '../../lib/apollo';
import { memberStatusMixin } from './memberStatusMixin';
import MypageMenuFooter from './MypageMenuFooter';

export default {
    components: {
        MypageSideMenu,
        MypageMenuFooter,
        MypageHeader,
        Card
    },
    mixins: [memberStatusMixin],
    data () {
        return {
            page_title: 'LINEアカウント連携',
            member_no: null,
            full_name: null,
            line_res_code: '',
            error_message: '',
            error_message_val: false
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize () {
            // LINEからのコールバック時
            if(this.$route.query.code){
                let url = process.env.MIX_GRAPHQL_URI + 'graphql?code=' + this.$route.query.code;
                const client = createApollo(url);

                this.$store.commit("loading/setIsLoading", true);

                client.mutate({
                    mutation: LINK_SOCIAL_ACCOUNT_TO_MEMBER,
                }).then(res => {
                    this.$router.push({ path: '/mypage-line-setting-complete' });
                }).catch(error => {
                    if (error.graphQLErrors[0].message === '既にLINEアカウント連携が利用されています。') {
                        this.error_message_val = true;
                        this.error_message = error.graphQLErrors[0].message
                    } else {
                        this.error_message_val = true;
                        this.error_message = this.$t("error.validation.systemError");
                    }
                    this.$store.commit("loading/setIsLoading", false);
                });
            }
            this.GetLoginUserMemberStatus();
            this.member_no = this.$store.state.auth.loginMember.member_no;
            this.full_name =
                this.$store.state.auth.loginMember.family_name +
                " " +
                this.$store.state.auth.loginMember.given_name;
        },
        /** ----------------------------------------------
         * LINE認証URL取得
         * ---------------------------------------------- */
        lineLink () {
            this.$store.commit("loading/setIsLoading", true);
            this.$apollo.mutate({
                mutation: GET_SOCIAL_AUTH_URL,
                variables: { }
            }).then(res => {
                window.location.href = res.data.getSocialAuthUrl.url;
            }).catch(error => {
                this.$store.commit("loading/setIsLoading", false);
                this.error = error;
            });
        },
        /** ----------------------------------------------
         * マイページトップに戻るボタン処理
         * ---------------------------------------------- */
        BackMyPage: function (){
            // マイページトップ画面へ遷移
            this.$router.push({ path: '/mypage' });
        }
    }
}

</script>

<style scoped>
</style>
